module.exports = __webpack_public_path__ + "835d43f9bc7ab43f0a0d8439f9f3b08e.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/social/speakers/michael-henretty.jpg
// module id = 519
// module chunks = 0